import { ReactNode } from 'react';

import { useResourceLinkExtensions } from '../../extensions';

export interface ResourceNameLinkProps {
  name: string;
  text: ReactNode;
  className?: string;
}

export const ResourceNameLink = ({
  name,
  text,
  className,
}: ResourceNameLinkProps) => {
  const extensions = useResourceLinkExtensions();

  const extension = extensions.find(e => e.predicate({ name, text }));
  if (extension) {
    return extension.render({ name, text, className });
  }

  return <strong data-resource-ref={name}>{text}</strong>;
};
